// PERSISTED

// NON PERSISTED

export const getIsSyncing = (state) => {
  return state.VNSyncManager.get('isSyncing')
}

export const getIsAutomatic = (state) => {
  return state.VNSyncManager.get('isAutomatic')
}

export const getSyncErrorCallback = (state) => {
  return state.VNSyncManager.get('errorCallback')
}

export const getDataIsUploading = (state) => {
  return state.VNSyncManager.get('dataIsUploading')
}

export const getSafIsUploading = (state) => {
  return state.VNSyncManager.get('safIsUploading')
}

export const getSafStatusRequesting = (state) => {
  return state.VNSyncManager.get('safStatusRequesting')
}

export const getSafStatusProgress = (state) => {
  return state.VNSyncManager.get('safStatusProgress')
}

export const getSomethingToSync = (state) => {
  return state.VNSyncManager.get('somethingToSync')
}

export const getStateCount = (state) => {
  return state.VNSyncManager.get('stateCount')
}

export const getSafCount = (state) => {
  return state.VNSyncManager.get('safCount')
}

export const getDataCount = (state) => {
  return state.VNSyncManager.get('dataCount')
}

export const getOrdersToSyncCount = (state) => {
  const stateCount = getStateCount(state)
  const safCount = getSafCount(state)
  const dataCount = getDataCount(state)

  return Math.max(stateCount, safCount, dataCount)
}
